// Event Tracking for GA
document.addEventListener('DOMContentLoaded', function () {
    const debugMode = enableDebugMode;
    // Define all DOM elements
    let trackingElements = {
        vehicleSelect: document.querySelector('.Vehicle_your_select .btn-link'),
    };

    const postInitVehicleFormTracking = () => {
        trackingElements.headerWrapper = document.querySelector('#header-new');
        trackingElements.yearSelect = trackingElements.headerWrapper.querySelector('#year-1');
        trackingElements.makeSelect = trackingElements.headerWrapper.querySelector('#make-1');
        trackingElements.modelSelect = trackingElements.headerWrapper.querySelector('#model-1');
        trackingElements.submodelSelect = trackingElements.headerWrapper.querySelector('#submodel-1');
        trackingElements.viewProductsBtn = trackingElements.headerWrapper.querySelector('#submodel-1 ~ div button');
        trackingElements.clearButton = trackingElements.headerWrapper.querySelector('.clear-link');
        trackingElements.closeModal = trackingElements.headerWrapper.querySelector('.close-modal');

        // Track year selection
        if (trackingElements.yearSelect) {
            trackingElements.yearSelect.addEventListener('change', function (e) {
                if (typeof gtag !== 'undefined') {
                    gtag('event', 'select_vehicle_step', {
                        'event_category': 'Vehicle Selection',
                        'event_label': 'Year Selected',
                        'step_name': 'year',
                        'step_status': 'complete',
                        'selection_value': e.target.value,
                        'debug_mode': debugMode
                    });
                }
            });
        }

        // Track make selection
        if (trackingElements.makeSelect) {
            trackingElements.makeSelect.addEventListener('change', function (e) {
                if (typeof gtag !== 'undefined') {
                    gtag('event', 'select_vehicle_step', {
                        'event_category': 'Vehicle Selection',
                        'event_label': 'Make Selected',
                        'step_name': 'make',
                        'step_status': 'complete',
                        'selection_value': e.target.value,
                        'debug_mode': debugMode
                    });
                }
            });
        }

        // Track model selection
        if (trackingElements.modelSelect) {
            trackingElements.modelSelect.addEventListener('change', function (e) {
                if (typeof gtag !== 'undefined') {
                    gtag('event', 'select_vehicle_step', {
                        'event_category': 'Vehicle Selection',
                        'event_label': 'Model Selected',
                        'step_name': 'model',
                        'step_status': 'complete',
                        'selection_value': e.target.value,
                        'debug_mode': debugMode
                    });
                }
            });
        }

        // Track submodel selection
        if (trackingElements.submodelSelect) {
            trackingElements.submodelSelect.addEventListener('change', function (e) {
                if (typeof gtag !== 'undefined') {
                    gtag('event', 'select_vehicle_step', {
                        'event_category': 'Vehicle Selection',
                        'event_label': 'Submodel Selected',
                        'step_name': 'submodel',
                        'step_status': 'complete',
                        'selection_value': e.target.value,
                        'debug_mode': debugMode
                    });
                }
            });
        }

        // Track form completion
        if (trackingElements.viewProductsBtn) {
            trackingElements.viewProductsBtn.addEventListener('click', function () {
                const year = trackingElements.yearSelect ? trackingElements.yearSelect.value : '';
                const make = trackingElements.makeSelect ? trackingElements.makeSelect.value : '';
                const model = trackingElements.modelSelect ? trackingElements.modelSelect.value : '';
                const submodel = trackingElements.submodelSelect ? trackingElements.submodelSelect.value : '';

                if (typeof gtag !== 'undefined') {
                    gtag('event', 'select_vehicle_step', {
                        'event_category': 'Vehicle Selection',
                        'event_label': 'Vehicle Selection Complete',
                        'step_name': 'complete',
                        'step_status': 'success',
                        'selection_value': `${year} ${make} ${model} ${submodel}`.trim(),
                        'debug_mode': debugMode
                    });
                }
            });
        }

        // Track clear button click
        if (trackingElements.clearButton) {
            trackingElements.clearButton.addEventListener('click', function () {
                if (typeof gtag !== 'undefined') {
                    gtag('event', 'select_vehicle_step', {
                        'event_category': 'Vehicle Selection',
                        'event_label': 'Vehicle Selection Cleared',
                        'step_name': 'clear',
                        'step_status': 'complete',
                        'debug_mode': debugMode
                    });
                }
            });
        }

        // Track close modal click
        if (trackingElements.closeModal) {
            trackingElements.closeModal.addEventListener('click', function () {
                if (typeof gtag !== 'undefined') {
                    gtag('event', 'select_vehicle_step', {
                        'event_category': 'Vehicle Selection',
                        'event_label': 'Vehicle Selector Closed',
                        'step_name': 'close',
                        'step_status': 'complete',
                        'debug_mode': debugMode
                    });
                }
            });
        }
    }

    // Track vehicle selector click event
    if (trackingElements.vehicleSelect) {
        trackingElements.vehicleSelect.addEventListener('click', function () {
            postInitVehicleFormTracking();

            if (typeof gtag !== 'undefined') {
                gtag('event', 'select_vehicle_step', {
                    'event_category': 'Vehicle Selection',
                    'event_label': 'Vehicle Selector Opened',
                    'step_name': 'init',
                    'step_status': 'started',
                    'debug_mode': debugMode
                });
            }
        });
    }
});
